import { colors } from '../constants/colors';
export var BASE_CFG = {
  data: {
    datasets: []
  },
  options: {
    responsive: true,
    maintainAspectRatio: false,
    animation: {
      easing: 'easeInOutQuad',
      duration: 520
    },
    legend: {
      display: false
    },
    elements: {
      line: {
        tension: 0,
        borderWidth: 2
      },
      point: {
        borderWidth: 2
      }
    },
    layout: {
      padding: 0
    },
    hover: {
      mode: 'index',
      intersect: false
    },
    scales: {
      x: {
        //https://www.chartjs.org/docs/next/axes/styling.html#grid-line-configuration
        ticks: {
          //see https://www.chartjs.org/docs/next/axes/radial/linear.html#tick-options
          fontColor: colors.GRAY_40,
          padding: 6,
          maxRotation: 0,
          stepSize: 1,
          lineHeight: 1.5,
          /** Эта опция отключает пропуски тиков, которые по мнению chart.js не помещаются в линию */
          autoSkip: false
        },
        gridLines: {
          //https://www.chartjs.org/docs/next/axes/styling.html#grid-line-configuration
          zeroLineColor: colors.GRAY_10,
          borderDash: [3, 3],
          zeroLineBorderDash: [3, 3],
          tickMarkLength: 5
        }
      },
      y: {
        position: 'right',
        offset: false,
        ticks: {
          //see https://www.chartjs.org/docs/next/axes/radial/linear.html#tick-options
          fontColor: colors.GRAY_40,
          padding: 12
        },
        gridLines: {
          // https://www.chartjs.org/docs/next/axes/styling.html#grid-line-configuration
          drawBorder: false,
          color: colors.GRAY_06,
          zeroLineColor: 'transparent',
          tickMarkLength: 0
        }
      }
    },
    tooltips: {
      enabled: true,
      backgroundColor: '#152242',
      cornerRadius: 4,
      caretSize: 0,
      caretPadding: 12,
      mode: 'index',
      intersect: false,
      displayColors: false
    }
  }
};
export var BASE_DATASET_CFG = {
  pointHoverBackgroundColor: '#FFFFFF',
  pointHoverBorderWidth: 2,
  pointHoverRadius: 4,
  pointRadius: 0,
  pointHitRadius: 4
};